import * as moment from 'moment';

var DateUtils = {
    formatForDateTimeInput: function(date) {
        if (date) {
            return moment(date).format("YYYY-MM-DDThh:mm");
        } else {
            return null;
        }
    }
}

export default DateUtils;